import React from 'react';
import MainPage from './pages/MainPage';

const App: React.FC = () => {
  return <MainPage />;
};

export default App;
